module.exports = __webpack_public_path__ + "static/img/7en.4dc7fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/7en.png
// module id = mlRu
// module chunks = 0